import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import logger from '../utils/frontendLogger';

const RouteTracker = ({ history }) => {
    useEffect(() => {
        // Track initial page load (in addition to the one in index.js)
        const trackPageView = (location) => {
            const page = location.pathname + location.search;
            logger.pageView(page, {
                referrer: document.referrer,
                screenResolution: `${window.screen.width}x${window.screen.height}`
            });
        };

        // Track initial page
        trackPageView(history.location);

        // Track route changes
        const unlisten = history.listen((location) => {
            trackPageView(location);
        });

        return () => {
            unlisten();
        };
    }, [history]);

    return null; // This component doesn't render anything
};

export default withRouter(RouteTracker);